import { Auth } from '../../services';
import Alert from '../ui/alert';

const markup = `<db:signup>
	<div class='details'>
		<form data-id='signUpForm'>
			<div>Start signin up here:</div>
			<div>
				<label>Username</label>
				<input type='text' data-id='username' data-property='value' />
			</div>
			<div>
				<label>Email</label>
				<input type='text' data-id='email' data-property='value' />
			</div>
			<div>
			<label>Password</label>
				<input type='password' data-id='password' data-property='value' />
			</div>
			<div>
				<input type='submit' value='Sign Up' />
			</div>
		</form>

		<hr />

		<form data-id='confirmEmailForm'>
		<div>Finish signing up here:</div>
		<div>
			<label>Your Verification Code</label>
			<input type='text' data-id='code' data-property='value' />
		</div>
		<div>
			<input type='submit' value='Confirm' />
		</div>
	</form>
	</div>
</db:signup>`;

const SignUp = DomClass(markup, function() {
	let username;

	this.__dom.signUpForm.onsubmit = () => {
		const spinner = new Spinner({
			message: "Signing up ..."
		});
		spinner.open();

		Auth.signUp({
			username: this.username,
			password: this.password,
			attributes: {
				email: this.email
			},
			autoSignIn: {
				enabled: true
			}
		}).then(r => {
			spinner.close();
			new Alert({message: "Confirmation code sent!\nEnter it below."})
		}).catch(error => {
			spinner.close();
			console.error('Signup error', error);
			new Alert({message: "Error signing up. Please try again."});
		});
		return false;
	};

	this.__dom.confirmEmailForm.onsubmit = () => {
		const spinner = new Spinner({
			message: "Confirming email address ..."
		});
		spinner.open();

		Auth.confirmSignUp(this.username, this.code).then(r => {
			spinner.close();
			this.username = '';
			this.password = '';
			this.code = '';
			new Alert({message: "All signed up! Try your new creds by signing in."})
			on(this, 'complete').fire(r);
		}).catch(error => {
			spinner.close();
			console.error("Confirm email error", error);
			new Alert({message: "There was an error confirming your email. Please try again."});
		});
		return false;
	};

	
});

export default SignUp;
